import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { Box, Divider, Grid, makeStyles, Typography } from "@material-ui/core";

import { BUILDING_SEGMENT_NAMES, BUILDING_SEGMENTS, MAIN_SYSTEMS } from "../../constants";
import { Icon, Select } from "../../components/base";
import { LogoText } from "../../components/logoText";
import Logo from "../../assets/images/icons/logo.svg";
import BellIcon from "../../assets/images/icons/bell.svg";
import SearchIcon from "../../assets/images/icons/search.svg";
import userSvg from "../../assets/images/dashboard/usersvg.svg";
import { selectCluster, selectSegments, selectCountries } from "../../redux/selectCSC/actions";
import { setCSC } from "../../redux/auth/actions";
import { getData } from "../../services";
import { getProfileData } from "../../redux/profile/actions";
import { RightNavigator } from "./RightNavigator";
import { USER_ROLES } from "../../services/constants";
import MenuIcon from "../../assets/images/icons/MenuIcon.svg";
import { AppsCard } from "./AppsCard";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    flexWrap: "noWrap",
  },
  img: {
    width: 32,
    cursor: "pointer",
  },
  companyName: {
    fontWeight: "bold",
    marginLeft: theme.spacing(8),
    [theme.breakpoints.down("sm")]: {
      marginLeft: theme.spacing(2),
    },
  },
  iconButton: {
    marginLeft: theme.spacing(3),
  },
  avatarIconButton: {
    marginLeft: theme.spacing(3),
    border: "1px solid #E8E8E8",
    borderRadius: 100,
    width: 40,
    height: 40,
  },
  renderValue: {
    fontWeight: 700,
  },
}));

export const Header = ({ onHoverLogo }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { clusters, countries } = useSelector((state) => state.auth);
  const { cluster, segments, selectedCountries } = useSelector((state) => state.selectCSC);
  const { systemType } = useSelector((state) => state.selectSystemType);
  const { profileData } = useSelector((state) => state.profile);
  const [showCard, setShowCard] = useState(false);
  const [showAppsCard, setShowAppsCard] = useState(false);

  useEffect(() => {
    dispatch(getProfileData());
  }, []);

  useEffect(() => {
    getData("/auth/csc/", (data) => dispatch(setCSC(data)));
  }, []);

  const display = () => {
    setShowCard(!showCard);
  };

  const displayAppsCard = () => {
    setShowAppsCard(!showAppsCard)
  }

  return (
    <>
      <Grid className={classes.root} container justifyContent="space-between" alignItems="center">
        <Grid item container alignItems="center" style={{ flexWrap: "nowrap" }}>
          <img
            className={classes.img}
            onMouseEnter={onHoverLogo}
            src={
              cluster?.logo
                ? `${process.env.REACT_APP_API_URL.replace("/api", "")}${cluster.logo}`
                : Logo
            }
            alt="logo"
            style={{
              width: cluster?.logo_width ? cluster.logo_width : null,
            }}
          />

          <Typography className={classes.companyName} variant="h2" align="center">
            {cluster?.name || <LogoText />}
          </Typography>

          {MAIN_SYSTEMS.indexOf(systemType) !== -1 ? (
            <Grid
              container
              style={{ flexWrap: "nowrap", marginLeft: 20, width: "auto", paddingTop: 4 }}
              spacing={2}
            >
              <Grid item container style={{ flexWrap: "nowrap" }} alignItems="baseline">
                <Typography style={{ marginRight: 5 }}>Cluster:</Typography>
                <Select
                  options={clusters}
                  value={cluster}
                  onChange={(v) => dispatch(selectCluster(v))}
                  renderValueClass={classes.renderValue}
                />
              </Grid>
              <Grid item container style={{ flexWrap: "nowrap" }} alignItems="baseline">
                <Typography style={{ marginRight: 5 }}>Segment:</Typography>
                <Select
                  multiple={true}
                  displayEmpty={true}
                  multiplePlaceHolder="All"
                  options={BUILDING_SEGMENTS}
                  optionNames={BUILDING_SEGMENT_NAMES}
                  value={segments}
                  onChange={(v) => dispatch(selectSegments(v))}
                  renderValueClass={classes.renderValue}
                />
              </Grid>
              <Grid item container style={{ flexWrap: "nowrap" }} alignItems="baseline">
                <Typography style={{ marginRight: 5 }}>Country:</Typography>
                <Select
                  multiple={true}
                  displayEmpty={true}
                  multiplePlaceHolder="All"
                  options={countries}
                  optionNames={countries}
                  value={selectedCountries}
                  onChange={(v) => dispatch(selectCountries(v))}
                  renderValueClass={classes.renderValue}
                />
              </Grid>
            </Grid>
          ) : null}
        </Grid>

        <Grid container alignItems="center" justifyContent="flex-end">
          {cluster.user_role !== USER_ROLES.bop ? <RightNavigator show={showCard} /> : <div />}
          <AppsCard show={showAppsCard} />
          <Icon root={classes.iconButton} src={SearchIcon} hoverable />
          <Icon root={classes.iconButton} src={BellIcon} hoverable />
          <Box sx={{
            cursor: "pointer"
          }}
            className={classes.iconButton}
            onClick={displayAppsCard}
          >
            <img
              src={MenuIcon}
              alt="logo"
            />

          </Box>
          {profileData?.avatar_url ? (
            <Icon
              root={classes.avatarIconButton}
              src={profileData?.avatar_url}
              hoverable
              onClick={display}
            />
          ) : (
            <Icon root={classes.avatarIconButton} src={userSvg} hoverable onClick={display} />
          )}
        </Grid>
      </Grid>
      <Divider />
    </>
  );
};
